import richTextInitialHtml from "./rich_text_initial_html"

const THEMES = ["brand", "muted", "success", "warning", "lime", "error"]

export default class CardZoneTool {
  static get enableLineBreaks() {
    return true
  }

  static get toolbox() {
    return {
      title: "Card zone",
      icon: "<span class=\"icon-[lucide--grid-2x2] size-4\"></span>"
    }
  }

  static get sanitize() {
    return {
      label: false,
      name: false,
      desc: {
        br: true,
        div: true
      },
      theme: false
    }
  }

  constructor({ data, readOnly } = {}) {
    this.readOnly = Boolean(readOnly)
    this.data = {
      label: data?.label || "",
      name: data?.name || "",
      desc: richTextInitialHtml(data?.desc || ""),
      theme: this.normalizeTheme(data?.theme)
    }
    this.themeButtons = new Map()
    this.wrapper = null
    this.labelInput = null
    this.nameInput = null
    this.descInput = null
  }

  render() {
    this.wrapper = document.createElement("div")
    this.wrapper.className = "editorjs-zone-card"

    this.labelInput = document.createElement("input")
    this.labelInput.type = "text"
    this.labelInput.placeholder = "Zone label (e.g. Zone 1)"
    this.labelInput.className = "editorjs-zone-card__label zone-card-label"
    this.labelInput.value = this.data.label

    this.nameInput = document.createElement("input")
    this.nameInput.type = "text"
    this.nameInput.placeholder = "Zone name"
    this.nameInput.className = "editorjs-zone-card__name zone-card-name"
    this.nameInput.value = this.data.name

    this.descInput = document.createElement("div")
    this.descInput.className = "editorjs-zone-card__desc zone-card-desc"
    this.descInput.setAttribute("data-placeholder", "Zone description")
    this.descInput.contentEditable = this.readOnly ? "false" : "true"
    this.descInput.innerHTML = this.data.desc

    this.labelInput.addEventListener("input", () => {
      this.data.label = this.labelInput.value
    })
    this.nameInput.addEventListener("input", () => {
      this.data.name = this.nameInput.value
    })

    this.wrapper.append(this.labelInput, this.nameInput, this.descInput)
    this.applyThemeClass()
    return this.wrapper
  }

  renderSettings() {
    const settings = document.createElement("div")
    settings.className = "editorjs-zone-card-settings"

    THEMES.forEach((theme) => {
      const button = document.createElement("button")
      button.type = "button"
      button.className = "editorjs-zone-card-settings__btn"
      button.textContent = this.themeLabel(theme)
      this.themeButtons.set(theme, button)

      button.addEventListener("click", () => {
        this.data.theme = theme
        this.updateSettingsButtonsState()
        this.applyThemeClass()
      })

      settings.appendChild(button)
    })

    this.updateSettingsButtonsState()
    return settings
  }

  save() {
    return {
      label: this.labelInput?.value || "",
      name: this.nameInput?.value || "",
      desc: this.descInput?.innerHTML || "",
      theme: this.normalizeTheme(this.data.theme)
    }
  }

  validate(savedData) {
    const label = (savedData?.label || "").trim()
    const name = (savedData?.name || "").trim()
    const tmp = document.createElement("div")
    tmp.innerHTML = savedData?.desc || ""
    const desc = (tmp.textContent || "").trim()
    return Boolean(label || name || desc)
  }

  applyThemeClass() {
    if (!this.wrapper) return

    THEMES.forEach((theme) => {
      this.wrapper.classList.remove(`editorjs-zone-card--${theme}`)
    })

    this.wrapper.classList.add(`editorjs-zone-card--${this.normalizeTheme(this.data.theme)}`)
  }

  updateSettingsButtonsState() {
    this.themeButtons.forEach((button, theme) => {
      button.classList.toggle("editorjs-zone-card-settings__btn--active", this.data.theme === theme)
    })
  }

  normalizeTheme(theme) {
    return THEMES.includes(theme) ? theme : "brand"
  }

  themeLabel(theme) {
    switch (theme) {
    case "brand":
      return "Brand"
    case "muted":
      return "Muted"
    case "success":
      return "Success"
    case "warning":
      return "Warning"
    case "lime":
      return "Lime"
    case "error":
      return "Error"
    default:
      return "Brand"
    }
  }
}
